export default __webpack_public_path__ + "static/media/copyImageIcon.14a1de97.webp";